const _ = require('lodash');
const Q = require('Q');

function decorateReview(review, hasProductName = false, hasProfileLink = false, hasProductLink = false) {
    review.reviewId = review._id.substr(review._id.lastIndexOf('/') + 1);
    review.wouldRecommend = _.isNull(review.wouldRecommend) ? false : review.wouldRecommend;
    review.productTitle = _.isNull(review.productTitle) ? '' : review.productTitle;
    review.displayOptions = { hasProductName, hasProfileLink, hasProductLink };
    review.urlFriendlyProductTitle = _.kebabCase(review.productTitle);
    review.urlDisplayName = _.kebabCase(review.displayName);
    review.reviewAsStaffMember = !_.isNull(review.reviewAsStaffMember) ?
        ((review.reviewAsStaffMember.toLowerCase() === 'yes') ? true : false) : false;
}

function ReviewService(ProxyService, BazaarvoiceService, SecureApiCall, ReviewApiRoutes, UrlService) {
    this.proxyService = ProxyService;
    this.bazaarvoiceService = BazaarvoiceService;
    this.secureApi = SecureApiCall;
    this.routes = ReviewApiRoutes;
    this.urlService = UrlService;
}

ReviewService.prototype.add = function (review) {
    return this.secureApi.call((token, header) => {
        const url = this.urlService.decorate(this.routes.add, token, review);
        return this.proxyService.post(url, this.routes.proxyName, JSON.stringify(review), JSON.stringify(header));
    });
};

ReviewService.prototype.addBVReview = function (review) {
    return this.bazaarvoiceService.postReview(JSON.stringify(review));
};

ReviewService.prototype.vote = function (vote) {
    return this.secureApi.call((token, header) => {
        const url = this.urlService.decorate(this.routes.vote, token, vote);
        return this.proxyService.put(url, this.routes.proxyName, JSON.stringify(vote), JSON.stringify(header));
    });
};

ReviewService.prototype.report = function (report) {
    return this.secureApi.call((token, header) => {
        const url = this.urlService.decorate(this.routes.report, token, report);
        return this.proxyService.put(url, this.routes.proxyName, JSON.stringify(report), JSON.stringify(header));
    });
};

ReviewService.prototype.getByProductId = function (product, options) {
    const path = this.urlService.decorate(this.routes.getByProductId, product, options);
    return this.proxyService.get(path, this.routes.proxyName).then(response => {
        _.each(response.reviews, (review) => {
            decorateReview(review, false /* hasProductTitle */, true /* hasProfileLink */);
        });
        return response;
    });
};

ReviewService.prototype.getBVReviewsByProductId = function (product, options) {
    const pagesize = options.limit || '';
    const pageoffset = options.offset || '';
    const sort = options.sort || '';
    return this.bazaarvoiceService.get(product.productId, '', sort, pagesize, pageoffset).then(response => {
        _.each(response.reviews, (review) => {
            decorateReview(review, false /* hasProductTitle */, true /* hasProfileLink */);
        });
        return response;
    });
};

ReviewService.prototype.getByShopperId = function (shopper, options) {
    const path = this.urlService.decorate(this.routes.getByShopperId, shopper, options);

    return this.proxyService.get(path, this.routes.proxyName).then(data => {
        _.each(data.reviews, (review) => {
            decorateReview(review, true /* hasProductTitle */, false /* hasProfileLink */, true /* hasProductLink */);
        });
        return data;
    });
};

ReviewService.prototype.getBVReviewsByShopperId = function (shopper, options) {
    const pagesize = options.limit || '';
    const pageoffset = options.offset || '';
    const sort = options.sort || '';
    return this.bazaarvoiceService.get('', shopper.shopperId, sort, pagesize, pageoffset).then(data => {
        _.each(data.reviews, (review) => {
            decorateReview(review, true /* hasProductTitle */, false /* hasProfileLink */, true /* hasProductLink */);
        });
        return data;
    });
};

ReviewService.prototype.getByStoreId = function () {
    // TODO: Implement when APIGEE API has been added for this route
    // 30/06 Update this route is still in play
    return Q.resolve([]);
};

module.exports = ReviewService;


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/customer-reviews/review-service.js
 **/